import { Component, ElementRef, NgZone, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SafrattiRequestService } from "src/services/safratti-request.service";
import { Location } from "@angular/common";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { OrderService } from "src/services/order.service";
import { SafrattiOrderDetail } from "src/models/safratti-order-detail";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { OwlOptions } from "ngx-owl-carousel-o";
import { GTSService } from "src/services/gts.service";
import { HttpClient } from "@angular/common/http";
import { SafrattiPolicy } from "src/models/sendPolicyEmail";
import { environment } from "src/environments/environment";
import { Observable, switchMap } from "rxjs";
import { CompanyService } from "src/services/company.service";
import { PolicyDocumentServiceFactory, PolicyDetails } from "src/services/factory/policy-document-service-factory";
import { StorageService } from "src/services/storage.service";
import { TplService } from "src/services/tpl.service";

@Component({
  selector: "app-safratti-policy-status",
  templateUrl: "./safratti-policy-status.component.html",
  styleUrls: ["./safratti-policy-status.component.css"],
})
export class SafrattiPolicyStatusComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: false,
  };

  constructor(
    private safrattiService: SafrattiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private order: OrderService,
    private _gtsService: GTSService,
    private http: HttpClient, 
    private _companyService: CompanyService,
    private tplService: TplService,
    private el: ElementRef,
    private renderer: Renderer2,
    private _policyDocumentServiceFactory: PolicyDocumentServiceFactory,
    private _storageService: StorageService,
    private zone: NgZone
  ) {}

  step = 0;
  pageTitle = "Safratti Request";
  orderDetail: SafrattiOrderDetail;
  isGTSPolicy = false;
  policyCopyUrl: SafeResourceUrl;
  receiptUrl: SafeResourceUrl;
  termsAndCondition: SafeResourceUrl;


  private _certificateBlob: Blob;
  private _receiptBlob: Blob;
  private _termsBlob: Blob;

  ngOnInit(): void {
    const id = +this.route.snapshot.paramMap.get("id");

    const state: any = this.location.getState();
    if (state && state.policyIssuer) {
      const policyIssuer = state.policyIssuer;
      this.isGTSPolicy = policyIssuer === "Safratti" ? false : true;

      this.order.getOrderDetail(id).subscribe((orderDetail) => {
        this.orderDetail = orderDetail;
        window.localStorage["companyId"] = orderDetail.companyId;

        if (orderDetail.certificateUrl) {
          this._fetchAndEmbed(orderDetail.certificateUrl, (blob, url) => {
            this._certificateBlob = blob;
            this.policyCopyUrl = url;
          });
        }

        if (orderDetail.receiptUrl) {
          this._fetchAndEmbed(orderDetail.receiptUrl, (blob, url) => {
            this._receiptBlob = blob;
            this.receiptUrl = url;
          });
        }

        if (orderDetail.termsAndConditionsUrl) {
          this._fetchAndEmbed(orderDetail.termsAndConditionsUrl, (blob, url) => {
            this._termsBlob = blob;
            this.termsAndCondition = url;
          });
        }
      });
    }
  }


  private _fetchAndEmbed(
    apiUrl: string,
    callback: (blob: Blob, safeUrl: SafeResourceUrl) => void
  ): void {
    this.http.get(apiUrl, { responseType: "blob" }).subscribe((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      callback(blob, safeUrl);
    });
  }

  downloadDocument(blob: Blob, fileName: string): void {
    if (!blob) return;
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(objectUrl);
  }

  downloadCertificate(): void {
    this.downloadDocument(this._certificateBlob, "certificate.pdf");
  }

  downloadReceipt(): void {
    this.downloadDocument(this._receiptBlob, "receipt.pdf");
  }

  downloadTerms(): void {
    this.downloadDocument(this._termsBlob, "terms-and-conditions.pdf");
  }

  convertImageToBase64(imageUrl: string): Observable<string> {
    return this.http
      .get(imageUrl, { responseType: "blob" })
      .pipe(switchMap((blob: Blob) => this.convertBlobToBase64(blob)));
  }

  convertBlobToBase64(blob: Blob): Observable<string> {
    const reader = new FileReader();

    return new Observable<string>((observer) => {
      reader.onloadend = () => {
        const base64String = reader.result as string;
        observer.next(base64String);
        observer.complete();
      };

      reader.readAsDataURL(blob);
    });
  }

  regenerateDocuments() {
    const id = +this.route.snapshot.paramMap.get("id");
    const body = environment.authenticate;

    this._gtsService.authenticate(body).subscribe((res) => {
      this.safrattiService.getPolicyDetail(id).subscribe((policyDto) => {
        policyDto.token = res.token;
        this._getRequiredDetailsForUpload(policyDto);
      });
    });
  }

  private _getRequiredDetailsForUpload(policyDto: any) {
    this.safrattiService.getDefaultCompanyForSafratti().subscribe(
      (res: any) => {
        const safratti = res.safratti;
        const companyId = res.id;
        this.tplService.getSafrattiLabels(companyId).subscribe((res: any) => {
          const safrattiLables = res;
          const pdfUrl = environment.cdnUrl + "/company/" + safratti;
          this.convertImageToBase64(pdfUrl).subscribe((converted64) => {
            this._uploadTravelPolicyDocument(
              policyDto,
              safrattiLables,
              converted64
            );
          });
        });
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  private _uploadTravelPolicyDocument(
    userData: any,
    safrattiLables: any[],
    policyBkgImg: string
  ) {
    const cardDetails: PolicyDetails = {
      policyId: userData.gtsPolicyId,
      policyNumber: this.orderDetail.gtsPolicyId,
      startDate: userData.travelPeriod.startDate,
      endDate: userData.travelPeriod.endDate,
      name: `${userData.travelersDetails[0].firstName} ${userData.travelersDetails[0].lastName}`,
      token: userData.token,
      policyBkgImg: policyBkgImg,
      reference: userData.gtsPolicyId,
      agent: this.orderDetail.agent,
      date: this.orderDetail.issueDate.toString(),
      fullName:
        userData.travelersDetails[0].firstName +
        " " +
        userData.travelersDetails[0].lastName,
      passportNo: userData.travelersDetails[0].passportNo,
      countryofResidence: userData.countryOfResidence,
      gender: userData.travelersDetails[0].gender,
      dateofBirth: userData.travelersDetails[0].dateOfBirth,
      phone: userData.phoneNumber,
      email: userData.email,
      plan: userData.plan,
      coverageZone: userData.coverageZone,
      from: userData.travelPeriod.startDate,
      to: userData.travelPeriod.endDate,
      sportsActivities: userData.sportsActivityIncluded,
      destination: userData.destinationCountry,
      periodofCover: this.orderDetail.periodOfCover,

      referencePosition: {
        x: safrattiLables[16]?.positionX,
        y: safrattiLables[16]?.positionY,
      },
      datePosition: {
        x: safrattiLables[3]?.positionX,
        y: safrattiLables[3]?.positionY,
      },
      agentPosition: {
        x: safrattiLables[0]?.positionX,
        y: safrattiLables[0]?.positionY,
      },
      fullNamePosition: {
        x: safrattiLables[8]?.positionX,
        y: safrattiLables[8]?.positionY,
      },
      passportNoPosition: {
        x: safrattiLables[12]?.positionX,
        y: safrattiLables[12]?.positionY,
      },
      countryofResidencePosition: {
        x: safrattiLables[1]?.positionX,
        y: safrattiLables[1]?.positionY,
      },
      genderPosition: {
        x: safrattiLables[9]?.positionX,
        y: safrattiLables[9]?.positionY,
      },
      dateofBirthPosition: {
        x: safrattiLables[4]?.positionX,
        y: safrattiLables[4]?.positionY,
      },
      phonePosition: {
        x: safrattiLables[14]?.positionX,
        y: safrattiLables[14]?.positionY,
      },
      emailPosition: {
        x: safrattiLables[7]?.positionX,
        y: safrattiLables[7]?.positionY,
      },
      planPosition: {
        x: safrattiLables[15]?.positionX,
        y: safrattiLables[15]?.positionY,
      },
      coverageZonePosition: {
        x: safrattiLables[2]?.positionX,
        y: safrattiLables[2]?.positionY,
      },
      fromPosition: {
        x: safrattiLables[18]?.positionX,
        y: safrattiLables[18]?.positionY,
      },
      toPosition: {
        x: safrattiLables[19]?.positionX,
        y: safrattiLables[19]?.positionY,
      },
      sportsActivitiesPosition: {
        x: safrattiLables[17]?.positionX,
        y: safrattiLables[17]?.positionY,
      },
      destinationPosition: {
        x: safrattiLables[6]?.positionX,
        y: safrattiLables[6]?.positionY,
      },
      periodofCoverPosition: {
        x: safrattiLables[13]?.positionX,
        y: safrattiLables[13]?.positionY,
      },
    };

    const policyDocumentService =
      this._policyDocumentServiceFactory.getPolicyDocumentService(cardDetails);

    policyDocumentService.uploadMembershipCard(() => {
      policyDocumentService.uploadPolicy(() => {
        this._snackBar.open("Documents Uploaded Successfully.", "Cancel");
      });
    });
  }

  sendEmail() {
    const id = +this.route.snapshot.paramMap.get("id");
    const body = environment.authenticate;

    this._gtsService.authenticate(body).subscribe((res) => {
      this.safrattiService.getPolicyDetail(id).subscribe((policyData) => {
        const safrattiPolicyEmail: SafrattiPolicy = {
          name:
            policyData.travelersDetails[0].firstName +
            " " +
            policyData.travelersDetails[0].lastName,
          to: [policyData.email],
          policyId: policyData.policyId,
        };
        this._gtsService.sendEmail(safrattiPolicyEmail).subscribe({
          next: () => {
            this._snackBar.open("Email sent successfully.", "Cancel");
          },
        });
      });
    });
  }

  goBack() {
    this.location.back();
  }
  goMofify() {
    const id = +this.route.snapshot.paramMap.get("id");
    this.router.navigate(["consumer-safratti-request/policy-detail/" + id]);
  }
  cancelPolicy() {
    const diloagRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Confirm",
        message: "Are you sure you want to cancel policy?",
      },
    });
    diloagRef.afterClosed().subscribe((result) => {
      const id = +this.route.snapshot.paramMap.get("id");
      if (result === "true") {
        this.safrattiService.cancelPolicy(id).subscribe((_) => {
          this._snackBar.open("Policy cancelled successfully.");
          this.location.back();
        });
      }
    });
  }

  updateRewardCreditStatus(isApproved: boolean) {
    this.safrattiService
      .updateRewardCredit(this.orderDetail.id, isApproved)
      .subscribe({
        next: () => {
          if (isApproved) {
            this._snackBar.open("Reward Credited Successfully.");
            window.location.reload();
          } else {
            this._snackBar.open("Reward credit rejected.");
            window.location.reload();
          }
        },
        error: () => {
          alert("Error in updating reward credit status");
        },
      });
  }
}
